import { render } from "./SwapTypeChart.vue?vue&type=template&id=0484d8ea"
import script from "./SwapTypeChart.vue?vue&type=script&lang=js"
export * from "./SwapTypeChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__